// src/apiClient.js
import axios from 'axios';

// Base URL from .env (e.g., REACT_APP_API_BASE=http://localhost:5000)
// Fallback to local dev if not set
export const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

// Create Axios instance
const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000, // 10s timeout to prevent hanging
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor: Add JWT auth if token exists (e.g., from login)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Assume token stored on login
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor: Global error handling (e.g., logout on 401)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized (e.g., logout)
      console.error('Unauthorized - logging out');
      localStorage.removeItem('token');
      // Optionally redirect to login
    }
    return Promise.reject(error);
  }
);

export default api;